import { lazy, Suspense } from "react";
import { ThemeToggle } from "@/components/ThemeToggle";
import type { City } from "@/lib/cities";
import type { GeoCoordinates } from "@/types/location";

const SettingsPanel = lazy(() =>
  import("@/components/SettingsPanel").then((m) => ({ default: m.SettingsPanel }))
);

interface Props {
  asrMethod: string;
  onAsrMethodChange: (method: string) => void;
  method: string;
  onMethodChange: (method: string) => void;
  coords: GeoCoordinates | null;
  onRefreshLocation: () => void;
  onCitySelect: (city: City) => void;
  notifications: boolean;
  onNotificationsChange: (enabled: boolean) => void;
}

export function Header({
  asrMethod,
  onAsrMethodChange,
  method,
  onMethodChange,
  coords,
  onRefreshLocation,
  onCitySelect,
  notifications,
  onNotificationsChange,
}: Props) {
  return (
    <header className="border-b">
      <div className="container max-w-md mx-auto px-4 h-14 flex items-center justify-between">
        <h1 className="text-lg font-bold tracking-tight">Miqat</h1>
        <div className="flex items-center gap-1">
          <ThemeToggle />
          <Suspense>
          <SettingsPanel
            asrMethod={asrMethod}
            onAsrMethodChange={onAsrMethodChange}
            method={method}
            onMethodChange={onMethodChange}
            coords={coords}
            onRefreshLocation={onRefreshLocation}
            onCitySelect={onCitySelect}
            notifications={notifications}
            onNotificationsChange={onNotificationsChange}
          />
          </Suspense>
        </div>
      </div>
    </header>
  );
}
